export default __webpack_public_path__ + "static/media/spinner.c5201e57.png";